import { createContext } from 'react';

const DeparturesContext = createContext();

export default DeparturesContext;